import React from "react";
import { useTranslation } from "utilities/i18n";

interface NoResultsIndicatorProps {
  title?: string; // optional - title to override the default title....
  className?: string;
}

/**
 * Render a "No results found" indicator, centered vertically and horizontally
 *
 * @example <NoResultsIndicator title="Please Wait..." />
 */
const NoResultsIndicator: React.FC<NoResultsIndicatorProps> = props => {
  const { t } = useTranslation();
  const classes = ["no-results-indicator", props.className || ""].join(" ");

  const title = props.title || t("NO_RESULTS");
  return (
    <div className={classes} data-testid="no-results-indicator">
      {title}
    </div>
  );
};

export default NoResultsIndicator;
